import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { FlexibleCalculationTemplateEditPage } from '@/areas/flexible-calculations/FlexibleCalculationTemplates/FlexibleCalculationTemplateEditPage';
import { canViewFlexibleCalculationTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';
import { SidebarPageContent } from '@/shared/ui/PageLayoutCollapsibleSidebar';

export const Route = createFileRoute(
    '/_authenticated/next/templates/flexible-calculation/$flexibleCalculationTemplateId',
)({
    staticData: {
        access: { permissions: canViewFlexibleCalculationTemplates },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return (
        <SidebarPageContent layoutVariant="fullWidth">
            <FlexibleCalculationTemplateEditPage
                flexibleCalculationTemplateId={pathParams.flexibleCalculationTemplateId}
            />
        </SidebarPageContent>
    );
}
